var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCostsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#152F4D",
    d: "M12.067 23.134a8.567 8.567 0 1 0 0-17.134 8.567 8.567 0 0 0 0 17.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.067 6.4a8.167 8.167 0 1 0 0 16.334 8.167 8.167 0 0 0 0-16.334ZM3.1 14.567a8.967 8.967 0 1 1 17.934 0 8.967 8.967 0 0 1-17.934 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#152F4D",
    d: "M12.067 19.134a8.567 8.567 0 1 0 0-17.134 8.567 8.567 0 0 0 0 17.134Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.067 2.4a8.167 8.167 0 1 0 0 16.334 8.167 8.167 0 0 0 0-16.334ZM3.1 10.567a8.967 8.967 0 1 1 17.934 0 8.967 8.967 0 0 1-17.934 0Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00F2B6",
    d: "M12.442 14.791v1.254h-.888v-1.247c-1.058-.07-2.085-.428-2.645-.932l.485-1.134c.529.447 1.341.775 2.16.85V11.34c-1.197-.302-2.488-.705-2.488-2.267 0-1.146.8-2.141 2.488-2.311V5.496h.888v1.247c.8.044 1.612.29 2.191.686l-.44 1.134a4.41 4.41 0 0 0-1.751-.605v2.268c1.196.302 2.506.692 2.506 2.254 0 1.146-.812 2.129-2.506 2.311Zm-.888-4.798V7.996c-.769.126-1.09.53-1.09 1.02 0 .536.466.788 1.09.977Zm2.009 2.588c0-.548-.473-.806-1.121-.995v1.984c.787-.126 1.12-.504 1.12-.989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCostsActive);
export default __webpack_public_path__ + "static/media/project-costs-active.925aa6ce569906e19d488e8efb2c1b05.svg";
export { ForwardRef as ReactComponent };